import { z } from 'zod';

import { BooleanParamSchema } from '../../common/boolean-param/boolean-param';
import { IdsParamSchema } from '../../common/ids-param/ids-param';
import { makeListQuery } from '../../common/list-query/list-query';
import { CityKeySchema } from '../city-key/city-key';

export const VENUE_SEARCH_MAX_LENGTH = 160;

/**
 * The admin venues list.
 *
 * `search` reaches the venue's **translated** name and city as well as the
 * staff-facing contact name, resolved across every locale — so an operator
 * reading the English list finds a venue by typing its Arabic name. The row then
 * renders in the locale they are reading, which is why the untitled fallback
 * exists rather than being a defect.
 *
 * `ids` is here from day one for the admin kit's `ServerSelect` (W6): P25b's
 * slot editor picks a venue, and a saved value has to render its label even when
 * that id is not on the page the picker happens to be showing.
 *
 * This schema decides which parameters may be **sent**; `VENUE_FILTER_SPEC` on
 * the api decides which column and operator each one reaches (N7). Both halves
 * are needed — a whitelist here with a passthrough there would be no whitelist.
 */
export const VenuesListQuerySchema = makeListQuery({
  isActive: BooleanParamSchema.optional(),
  cityKey: CityKeySchema.optional(),
  search: z.string().trim().min(1).max(VENUE_SEARCH_MAX_LENGTH).optional(),
  ids: IdsParamSchema.optional(),
});

export type VenuesListQuery = z.infer<typeof VenuesListQuerySchema>;
